
import React from 'react';

interface GoogleMapProps {
  address: string;
  businessName?: string;
  className?: string;
}

const GoogleMap: React.FC<GoogleMapProps> = ({ 
  address, 
  businessName = "Carolina Trophy Roofs", 
  className = "w-full h-96 rounded-lg shadow-lg" 
}) => {
  // Use the specific embed URL for Greenville, NC location
  const mapSrc = "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3244.087120143373!2d-77.37505999999999!3d35.6009175!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89aee7fe8cc00001%3A0xc20c0c573e2a4576!2s1414%20Forbes%20St%2C%20Greenville%2C%20NC%2027858!5e0!3m2!1sen!2sus!4v1750116481705!5m2!1sen!2sus";
  
  // Fallback to Google Maps search URL
  const encodedAddress = encodeURIComponent(address);
  const mapLinkUrl = `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`;

  return (
    <div className={className}>
      <iframe
        src={mapSrc}
        width="100%"
        height="100%"
        style={{ border: 0 }}
        allowFullScreen
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        title={`Map showing location of ${businessName} at ${address}`}
      />
      
      {/* Fallback link for when the embed doesn't work */}
      <div className="mt-2 text-center">
        <a
          href={mapLinkUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="text-brand-carolina-blue hover:text-brand-carolina-blue/80 text-sm underline"
        >
          View on Google Maps
        </a>
      </div>
    </div>
  );
};

export default GoogleMap;
